export default function clearLocalStorageExcept(keysToKeep: string[] = []): void {
  const savedData: Record<string, string> = {};

  keysToKeep.forEach((key: string) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      savedData[key] = value;
    }
  });

  localStorage.clear();

  for (const [key, value] of Object.entries(savedData)) {
    localStorage.setItem(key, value);
  }
}